<div class="ai-tokens-page">
  <div class="card">
    <div class="card__header">
      <div class="card__title">{{ 'ai_tokens.title' | translate }}</div>
    </div>
    <div class="card__body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="spinner"></div>
        <p>{{ 'loading' | translate }}...</p>
      </div>

      <div *ngIf="!isLoading">
        <!-- Balance Section -->
        <div class="section" *ngIf="balance">
          <h3 class="section__title">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            {{ 'ai_tokens.your_balance' | translate }}
          </h3>
          
            <!-- Total Balance Card -->
            <div class="card mb-4" [ngClass]="{'border-danger': isTotalBalanceOverused()}">
              <div class="card-body text-center py-4">
                <div class="mb-2">
                  <small class="text-muted text-uppercase">Total Token Balance</small>
                </div>
                <h1 class="mb-2" [ngClass]="{'text-danger': isTotalBalanceOverused(), 'text-success': !isTotalBalanceOverused()}">
                  {{ formatNumber(getTotalRemainingBalance()) }}
                  <span class="small" *ngIf="isTotalBalanceOverused()"> ({{ formatNumber(Math.abs(getTotalRemainingBalance())) }} overused)</span>
                </h1>
                <div class="mb-3">
                  <small class="text-muted">{{ formatNumber(getTotalTokensUsed()) }} / {{ formatNumber(getTotalTokensCapacity()) }}</small>
                </div>
                <div class="progress" style="height: 12px; background-color: #e9ecef; border-radius: 4px; overflow: hidden;">
                  <div
                    role="progressbar"
                    [style.width.%]="getTotalUsagePercentage()"
                    [style.height]="'100%'"
                    [style.background-color]="getTotalUsagePercentage() >= 90 ? '#dc3545' : (getTotalUsagePercentage() >= 75 ? '#ffc107' : '#28a745')"
                    [style.transition]="'width 0.3s ease'"
                    [attr.aria-valuenow]="getTotalUsagePercentage()"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="text-center mt-2">
                  <small class="text-muted">{{ getTotalUsagePercentage() }}% used</small>
                </div>
              </div>
            </div>

            <div class="card mb-4" *ngIf="subscriptionBalance">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <h3 class="card-title mb-1">Subscription Plan Balance</h3>
                    <small class="text-muted">AI tokens that come with your active subscription</small>
                  </div>
                  <div class="badge badge-soft-primary">Plan</div>
                </div>
            
                <div class="row">
                  <div class="col-md-4 mb-3 mb-md-0">
                    <div class="text-muted mb-1">Remaining</div>
                    <h4 class="mb-0">{{ subscriptionBalance.remaining | number }}</h4>
                  </div>
                  <div class="col-md-4 mb-3 mb-md-0">
                    <div class="text-muted mb-1">Used</div>
                    <h4 class="mb-0">{{ subscriptionBalance.used | number }}</h4>
                  </div>
                  <div class="col-md-4">
                    <div class="text-muted mb-1">Total</div>
                    <h4 class="mb-0">{{ subscriptionBalance.total | number }}</h4>
                  </div>
                </div>
                <div class="progress mt-3" style="height: 12px; background-color: #e9ecef; border-radius: 4px; overflow: hidden;">
                  <div
                    role="progressbar"
                    [style.width.%]="getSubscriptionUsagePercentage()"
                    [style.height]="'100%'"
                    [style.background-color]="getSubscriptionUsagePercentage() >= 90 ? '#dc3545' : (getSubscriptionUsagePercentage() >= 75 ? '#ffc107' : '#007bff')"
                    [style.transition]="'width 0.3s ease'"
                    [attr.aria-valuenow]="getSubscriptionUsagePercentage()"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="text-center mt-2">
                  <small class="text-muted">{{ getSubscriptionUsagePercentage() }}% used</small>
                </div>
              </div>
            </div>
              <div class="d-flex align-items-center gap-2 mb-3" *ngIf="balance?.aiTokensPurchased">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 6v6l4 2"></path>
                </svg>
                <span class="fw-semibold">Your token balance from the packages bought</span>
              </div>
          <div class="info-grid">
            <div class="info-item info-item--highlight">
              <span class="info-label">{{ 'ai_tokens.remaining' | translate }}</span>
              <span class="info-value info-value--large info-value--primary">{{ formatNumber(getPurchasedTokensRemaining()) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ 'ai_tokens.used' | translate }}</span>
              <span class="info-value">{{ formatNumber(getPurchasedTokensUsed()) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ 'ai_tokens.limit' | translate }}</span>
              <span class="info-value">{{ formatNumber(balance.aiTokensLimit) }}</span>
            </div>
            <div class="info-item" *ngIf="balance.aiTokensPurchased > 0">
              <span class="info-label">{{ 'ai_tokens.purchased' | translate }}</span>
              <span class="info-value info-value--success">{{ formatNumber(balance.aiTokensPurchased) }}</span>
            </div>
          </div>
          
          <div class="progress mt-3" style="height: 12px; background-color: #e9ecef; border-radius: 4px; overflow: hidden;">
            <div
              role="progressbar"
              [style.width.%]="getPurchasedUsagePercentage()"
              [style.height]="'100%'"
              [style.background-color]="getPurchasedUsagePercentage() >= 90 ? '#dc3545' : (getPurchasedUsagePercentage() >= 75 ? '#ffc107' : '#007bff')"
              [style.transition]="'width 0.3s ease'"
              [attr.aria-valuenow]="getPurchasedUsagePercentage()"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <p class="progress-text text-center mt-2">
            <small class="text-muted">{{ getPurchasedUsagePercentage() }}% {{ 'ai_tokens.of_limit_used' | translate }}</small>
          </p>
          
          <!-- Admin Actions Section -->
          <div class="row mt-4" *ngIf="balance">
            <div class="col-md-6 mb-3">
              <div class="card">
                <div class="card-body text-center">
                  <div class="text-muted mb-2">Gifted Tokens</div>
                  <h4 class="mb-0 text-success">{{ formatNumber(balance.adminTokensAdded || 0) }}</h4>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="card">
                <div class="card-body text-center">
                  <div class="text-muted mb-2">Deducted Tokens</div>
                  <h4 class="mb-0 text-danger">{{ formatNumber(balance.adminTokensDeducted || 0) }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="tabs">
          <button 
            class="tab-btn" 
            [class.active]="activeTab === 'packages'"
            (click)="setActiveTab('packages')">
            {{ 'ai_tokens.buy_tokens' | translate }}
          </button>
          <button 
            class="tab-btn" 
            [class.active]="activeTab === 'history'"
            (click)="setActiveTab('history')">
            {{ 'ai_tokens.purchase_history' | translate }}
          </button>
        </div>

        <!-- Packages Tab -->
        <div class="tab-content" *ngIf="activeTab === 'packages'">
          <div class="packages-grid" *ngIf="packages.length > 0">
            <div class="package-card" *ngFor="let pkg of packages" [class.popular]="pkg.isPopular">
              <div class="popular-badge" *ngIf="pkg.isPopular">
                {{ 'ai_tokens.popular' | translate }}
              </div>
              <div class="package-header">
                <h3 class="package-name">{{ getPackageName(pkg) }}</h3>
                <p class="package-description" *ngIf="getPackageDescription(pkg)">
                  {{ getPackageDescription(pkg) }}
                </p>
              </div>
              <div class="package-tokens">
                <span class="tokens-value">{{ formatNumber(pkg.tokensAmount) }}</span>
                <span class="tokens-label">{{ 'ai_tokens.tokens' | translate }}</span>
              </div>
              <div class="package-price">
                <span class="price-current">{{ pkg.price | currencyConvert: getCurrencyCode(pkg.currency) }}</span>
                <span class="price-original" *ngIf="pkg.discount > 0">
                  {{ pkg.originalPrice | currencyConvert: getCurrencyCode(pkg.currency) }}
                </span>
                <span class="discount-badge" *ngIf="pkg.discount > 0">
                  -{{ pkg.discount }}%
                </span>
              </div>
              <button 
                class="buy-btn" 
                (click)="purchasePackage(pkg)"
                [disabled]="isPurchasing">
                <span *ngIf="!isPurchasing">{{ 'ai_tokens.buy_now' | translate }}</span>
                <span *ngIf="isPurchasing">{{ 'ai_tokens.processing' | translate }}</span>
              </button>
            </div>
          </div>
          
          <div class="no-data" *ngIf="packages.length === 0">
            <div class="no-data__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="12" y1="8" x2="12" y2="16"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
              </svg>
            </div>
            <p>{{ 'ai_tokens.no_packages' | translate }}</p>
          </div>
        </div>

        <!-- History Tab -->
        <div class="tab-content" *ngIf="activeTab === 'history'">
          <div class="history-table" *ngIf="purchaseHistory.length > 0">
            <div class="table-header">
              <div class="col">{{ 'ai_tokens.package' | translate }}</div>
              <div class="col">{{ 'ai_tokens.tokens' | translate }}</div>
              <div class="col">{{ 'ai_tokens.price_paid' | translate }}</div>
              <div class="col">{{ 'ai_tokens.date' | translate }}</div>
            </div>
            <div class="table-row" *ngFor="let purchase of purchaseHistory">
              <div class="col">
                <span *ngIf="purchase.packageName">
                  {{ purchase.packageName.en || purchase.packageName.ar || '-' }}
                </span>
              </div>
              <div class="col tokens">+{{ formatNumber(purchase.tokensAmount) }}</div>
              <div class="col">{{ purchase.pricePaid | currencyConvert: getCurrencyCode(purchase.currency) }}</div>
              <div class="col date">{{ formatDate(purchase.purchasedAt) }}</div>
            </div>
          </div>

          <div class="no-data" *ngIf="purchaseHistory.length === 0">
            <div class="no-data__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <p>{{ 'ai_tokens.no_history' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
